import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/common/ScrollToTop";
import { Toaster } from "react-hot-toast";
import AppRoutes from "./routes/AppRoutes";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./features/auth/authSlice";
import { fetchCart } from "./features/cart/cartSlice";

export default function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const userId = useSelector((state) => state.auth.user?.idUser);

  useEffect(() => {
    const checkLogin = async () => {
      try {
        const res = await axios.get(`${process.env.BACKEND_URL}/api/user/me`, {
          withCredentials: true,
        });
        dispatch(setUser(res.data.user));
      } catch (err) {
        dispatch(setUser(null));
      }
    };

    checkLogin();
  }, [dispatch]);

  // Warenkorb zentral laden, sobald ein User bekannt ist (einzige Fetch-Stelle).
  useEffect(() => {
    if (userId) dispatch(fetchCart(userId));
  }, [userId, dispatch]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <Toaster position="top-center" reverseOrder={false} />
      <main className="flex-grow">
        <ScrollToTop />
        <AppRoutes />
      </main>
      <Footer />
    </div>
  );
}
